import { Helpers } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { ALLOWED_BUILDING_CLASSES, ALLOWED_BUILDING_TYPES } from '../constants/BuildingTypes';
import { FiltersCreateHelper } from '../../helpers/filtersCreateHelper';

const { ObjectHelper } = Helpers;

export default class BuildingTypeMapper {
  static mapListingToFilter(buildingType, buildingClass) {
    return ALLOWED_BUILDING_TYPES.includes(buildingType)
      ? buildingType
      : buildingClass;
  }

  static mapFilterToRequestQuery(buildingType) {
    return ObjectHelper.removeEmptyProperties({
      [QueryParams.BuildingType]: FiltersCreateHelper.getFilterValues(
        ALLOWED_BUILDING_TYPES, buildingType,
      ),
      [QueryParams.BuildingClass]: FiltersCreateHelper.getFilterValues(
        ALLOWED_BUILDING_CLASSES, buildingType,
      ),
    });
  }
}
